<template>

    <LoopItemPanel title="Slide">
        <div class="common-canvas-blocks-custom-logoSlider-admin-LoopItemPanel">

          <div class="tw-px-5 tw-py-3 text">
            <div class="tw-text-gray-600 label">Link</div>

            <small class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted"
               title="Hier kan je een link."
            >
              Typ hier de link van de pagina naar waar het item moet linken.
            </small>

            <input type="text" v-model="loopItem.link" class="tw-px-3 tw-py-2 tw-border focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-relative tw-block tw-w-full tw-rounded-none tw-rounded-md tw-bg-transparent focus:tw-z-10 sm:tw-text-sm tw-border-gray-300">

          </div>

        </div>
    </LoopItemPanel>

</template>

<script>

    import axios from 'axios';

    import LoopItemPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/loop/owlCarousel/LoopItemPanel";
    import SwitchInput from "../../../../../../../../packages/lav-galaxy/framework/resources/js/common/canvas/editor/canvas/document/editors/inputs/SwitchInput";
    import WebsitePageSelector from "../../../../../../../../packages/lav-galaxy/framework/resources/js/habitats/admin/common/WebsitePageSelector";

    export default {
        extends: LoopItemPanel,
        components: {
            LoopItemPanel,
            SwitchInput,
            WebsitePageSelector,

        },
        data()
        {
            return {
            };
        },

        methods: {

        }
    }
</script>
<style lang="scss" scoped>
    .common-canvas-blocks-custom-logoSlider-admin-LoopItemPanel {
    }

</style>
